<div class="p-grid">
    <div class="p-col-12">
        <div class="card">

            <div class="card-header p-grid">
                <div class="p-col-6">
                    <h1>{{title}}</h1>
                </div>
                <div class="p-col-6 p-text-right">
                    <ng-content select="[buttons]"></ng-content>
                </div>
            </div>

            <div aria-live="assertive">
                <p-messages [(value)]="messages"></p-messages>
            </div>
            <app-loader [loading]="loading"></app-loader>

            <ng-content *ngIf="loading !== true" select="[table]"></ng-content>

        </div>
    </div>
</div>
